/**
 * Asset-Detail (Route /asset/:short) — DÜNNER Wrapper um die prop-getriebene
 * AssetDetail-Komponente (C2.4). Liest den slug aus der URL, laedt das Entity
 * und reicht es durch. Ein Rendering-Pfad: identisch zum eingebetteten
 * Drilldown im Scroll-Cockpit (PortfolioPage).
 */
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api/client';
import type { Entity } from '../types/snapshot';
import { AssetDetail } from '../components/AssetDetail';

export function AssetDetailPage() {
  const { short = '' } = useParams();
  const [entity, setEntity] = useState<Entity | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setEntity(null);
    setError(null);
    api
      .getAsset(short)
      .then((e) => active && setEntity(e))
      .catch((e) => active && setError(e.message ?? 'Fehler beim Laden'));
    return () => {
      active = false;
    };
  }, [short]);

  if (error) {
    return (
      <div className="space-y-3">
        <p role="alert" className="text-ampel-red">
          {error}
        </p>
        <Link to="/" className="text-accent underline">
          ← Zurück zum Portfolio
        </Link>
      </div>
    );
  }
  if (!entity) {
    return <p className="text-text-muted">Lade Asset …</p>;
  }

  return (
    <div className="space-y-4">
      <Link to="/" className="text-sm text-accent underline">
        ← Portfolio
      </Link>
      <AssetDetail entity={entity} />
    </div>
  );
}
